import styled from 'styled-components';
import { compose, display, DisplayProps } from 'styled-system';

export const Br = styled.br<DisplayProps>`
  ${compose(display)};
`;
